module.exports = "/images/dma-loading.gif?ef7d60d090e9ee777674bacba82986ab";